// extracted by mini-css-extract-plugin
export default {"divImg":"HighlightProduct_divImg__soktW","divText":"HighlightProduct_divText__ni5A8"};